var map = {
	"./CommunityChecked.svg": "00e9",
	"./DiversityChecked.svg": "ac92",
	"./EnvironmentChecked.svg": "8e4e",
	"./IngredientsChecked.svg": "364a",
	"./ManufacturingChecked.svg": "50e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df9b";